import { APIPath } from 'utility/constant'
import { CRUDService } from './crud'
import { BaseService } from './base'
import { CommonUtility } from 'utility/common'

class Creators extends CRUDService {
  constructor() {
    super(APIPath.creators) // Initialize CRUDService with Creatorss API path
  }

  toggleBlock(id, block) {
    const url = `${APIPath.userBlock}/${id}/${block}`
    return BaseService.put(url)
  }

  getUserFollowers(id, filter) {
    const url = `${APIPath.getUserFollowersCreators}?user_id=${id}&${CommonUtility.objectToParams(
      filter,
    )}`
    return BaseService.get(url)
  }

  getUserFollowing(id, filter) {
    const url = `${APIPath.getUserFollowingCreators}?user_id=${id}&${CommonUtility.objectToParams(
      filter,
    )}`
    return BaseService.get(url)
  }

  getBlockedCreators(params) {
    const url = `${APIPath.users}/block-creators?${CommonUtility.objectToParams(params)}`
    return BaseService.get(url, this.isSecure)
}
}

// Initialize the service with the desired API path
const CreatorsService = new Creators(APIPath.creators)
Object.freeze(CreatorsService)

export { CreatorsService }
